import "@/styles/packages.scss"

import { application } from "../helpers/stimulus"

import { setupAccordions } from "@/components/content/Accordion"
import { setupVenueModals as setupFacilitiesModal } from "@/components/venue/modals"
import { Elm } from "@/components/elm/Venue/Modal.elm"
import DisclosureItemController from "../controllers/disclosure_item_controller"
import VoucherFormController from "../controllers/voucher_form_controller"
import TooltipController from "../controllers/tooltip_controller"

const setupStimulus = (): void => {
  application.register("disclosure-item", DisclosureItemController)
  application.register("voucher-form", VoucherFormController)
  application.register("tooltip", TooltipController)
}

setupStimulus()
setupFacilitiesModal(Elm.Venue)
setupAccordions()
